export const COLORS_PALETTE = {
  FIRST: 'TBD',
  SECOND: '#3c8dbc',
  THIRD: 'TBD',
  FOURTH: 'TBD',
  FITH: 'TBD'
}
